import TestResultRow from "./TestResultRow";
import { PanelResult } from "../../store/slices/order/types";
import MobileTestResult from "./MobileTestResult";
import {
  getPanelResultStatus,
  groupPanelResultDetailsByValueTypes,
} from "../../utils/result.utils";
import { ResultStatus } from "../../enums/resultStatus.enum";

const TestResultsTable = ({ panelResult }: { panelResult: PanelResult }) => {
  const availablePanelResultItems = panelResult.panelResultDetails.filter(
    (result) => result.strValue
  );

  const groupedResults = groupPanelResultDetailsByValueTypes(
    availablePanelResultItems
  );
  const panelResultStatus = getPanelResultStatus(availablePanelResultItems);
  
  return (
    <div className="mb-20 ">
      <div className="w-3/4 mx-auto text-center">
        <h3 className="text-[#2D2D31] text-[1.5rem] font-[500] mb-4">
          {panelResult?.panel?.name}
        </h3>
        {panelResultStatus === ResultStatus.Abnormal ? (
          <div className="bg-[#FEC472] flex justify-center w-3/4 lg:w-1/4 mx-auto p-2 rounded-full mb-4">
            <p className="text-sm text-[#100B00] font-[500]">
              Some Abnormal Results
            </p>
          </div>
        ) : panelResultStatus === ResultStatus.Good ? (
          <div className="bg-[#2EE290] flex justify-center  w-3/4 lg:w-1/4 mx-auto p-2 rounded-full mb-4">
            <p className="text-sm text-[#100B00] font-[500]">
              Everything Looks Good
            </p>
          </div>
        ) : null}

        <p className="text-[0.875rem] leading-6 font-[500] text-[#2D2D31] mb-7">
          {panelResult?.panel?.description}
        </p>
      </div>

      <div className="overflow-x-auto w-full mx-auto hidden lg:block">
        <table className="w-max lg:w-full text-center">
          <tbody className="">
            {groupedResults.map((resultDetails) => (
              <TestResultRow
                key={resultDetails._id}
                resultDetails={resultDetails}
              />
            ))}
          </tbody>
        </table>
      </div>

      {groupedResults.map((resultDetails) => (
        <MobileTestResult
          key={resultDetails._id}
          resultDetails={resultDetails}
        />
      ))}

      {/* <div className="bg-[#BFEBD6] px-4 py-6 mt-1">
                <h3 className="text-[#525256] text-[1rem] font-[700] mb-3">
                    Doctor's Note
                </h3>
                <p className=" text-[0.875rem] leading-6 font-light text-[#2D2D31]">
                    {results?.panelResult.printableComment}
                </p>
            </div> */}
    </div>
  );
};

export default TestResultsTable;
